import { createContext, useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export const SidebarContext = createContext({});

export const SidebarProvider = ({ children }) => {
	const navigate = useNavigate();
	const [isSidebarOpen, setSidebarOpen] = useState(false);

	useEffect(() => {
	}, []);

	const openSidebar = () => {
		setSidebarOpen(true);
	};

	const closeSidebar = () => {
		setSidebarOpen(false);
	};

	return (
		<SidebarContext.Provider
			value={{
				isSidebarOpen,
				openSidebar,
				closeSidebar,
			}}
		>
			{children}
		</SidebarContext.Provider>
	);
};

SidebarProvider.propTypes = {
	children: PropTypes.node,
};
